// extracted by mini-css-extract-plugin
export default {"cards":"cardsStack_cards__ZkneC","cardWrapper":"cardsStack_cardWrapper__M5QoK","notSelectedCardWrapper":"cardsStack_notSelectedCardWrapper__+tGM0"};